var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"wheel",rawName:"v-wheel",value:(_vm.onWheel),expression:"onWheel"}],attrs:{"id":"app"}},[_c('Header'),_c('Navigation'),_c('div',{staticClass:"container"},[_c('router-view')],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }